import oehGet from 'lodash/get'

const OrderingErrorHandler = {
  methods: {
    handleOrderingErrors(error) {
      let displayedErrorMessage = 'Okänt serverfel'
      //const status = oehGet(error, 'response.status', '500')

      try {
        const dataErrors = oehGet(error, 'response.data.errors', null)
        const messageErrors = oehGet(error, 'response.message.errors', null)

        if (dataErrors && dataErrors.length > 0) {
          displayedErrorMessage = dataErrors.map(error => {
            const object = oehGet(error, 'entity.displayName', 'Data')
            const field = oehGet(error, 'value.displayName', 'värde')
            return `${object} saknar ${field.toLowerCase()}`
          }).join(', ')
        } else if (messageErrors && messageErrors.length > 0) {
          displayedErrorMessage = messageErrors.map(error => {
            const object = oehGet(error, 'entity.displayName', 'Data')
            return `${object} saknas`
          }).join(', ')
        } else if (typeof error === 'string') {
          displayedErrorMessage = error
        }
      } catch {
        //
      }

      return this.$dialog.notify.error('Kunde inte beställa: '+ displayedErrorMessage, {position: 'top-right', outlined: true})
    }
  }
}
export default OrderingErrorHandler
